export default "__VITE_ASSET__C1nB5lU7__"